// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../../../../node_modules/rescript/lib/es6/array.js";
import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Icon$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/icons/Icon.bs.js";
import * as AddressCardCmp from "./AddressCardCmp.bs.js";
import * as CountryContext from "../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as PlaceOrderContext from "../../context/PlaceOrderContext.bs.js";
import * as PlaceOrderGaConfig from "../../../app/helper/PlaceOrderGaConfig.bs.js";
import * as PlaceOrderAssetsManager from "../../assets/PlaceOrderAssetsManager.bs.js";

var locationLine = PlaceOrderAssetsManager.getImage("location-line.svg");

function PickAndDropSectionCmp(Props) {
  var match = PlaceOrderContext.useContext(undefined);
  var state = match.state;
  var wayPointThree = state.wayPointThree;
  var wayPointTwo = state.wayPointTwo;
  var wayPointOne = state.wayPointOne;
  var customerInfo = state.customerInfo;
  var dispatch = match.dispatch;
  var match$1 = CountryContext.useContext(undefined);
  var country = match$1.country;
  var enabledWayPoints = [
      wayPointOne,
      wayPointTwo,
      wayPointThree
    ].filter(function (e) {
        return e.showForm;
      });
  var getWayPointAddressCmp = function (wayPoint) {
    if (wayPoint.showForm) {
      return React.createElement(AddressCardCmp.make, {
                  address: wayPoint.address
                });
    } else {
      return null;
    }
  };
  return React.createElement("div", {
              className: "section__container"
            }, React.createElement("div", {
                  className: "header"
                }, React.createElement("p", {
                      className: "title"
                    }, "PICK UP AND DROP"), state.currentStep >= 2 ? React.createElement("div", {
                        onClick: (function (param) {
                            PlaceOrderGaConfig.publishEvent({
                                  category: /* ConfirmOrder */3,
                                  action: "Edit Address",
                                  label: "1_" + customerInfo.mobile,
                                  value: undefined,
                                  nonInteraction: undefined
                                }, country);
                            return Curry._1(dispatch, {
                                        TAG: /* ChangeCurrentStep */0,
                                        _0: /* PickupDropStep */0
                                      });
                          })
                      }, React.createElement(Icon$Catalyst.EditIcon.make, {}), " Edit") : null), React.createElement("div", {
                  className: "content__container"
                }, React.createElement("div", {
                      className: "location_marker"
                    }, React.createElement("div", {
                          className: "pin pickup"
                        }), React.createElement("div", {
                          className: "line_track"
                        }), $$Array.mapi((function (i, param) {
                            return React.createElement(React.Fragment, undefined, React.createElement("div", {
                                            className: "pin waypoint"
                                          }, String(i + 1 | 0)), React.createElement("div", {
                                            className: "line_track"
                                          }));
                          }), enabledWayPoints), React.createElement("div", {
                          className: "pin drop"
                        })), React.createElement("div", {
                      className: "address-cards"
                    }, React.createElement(AddressCardCmp.make, {
                          address: state.pickupAddress
                        }), getWayPointAddressCmp(wayPointOne), getWayPointAddressCmp(wayPointTwo), getWayPointAddressCmp(wayPointThree), React.createElement(AddressCardCmp.make, {
                          address: state.dropAddress
                        }))));
}

var make = PickAndDropSectionCmp;

export {
  locationLine ,
  make ,
  
}
/* locationLine Not a pure module */
